import React from "react";
import { Button, Card, Header, List } from "semantic-ui-react";

import IOffice from "../../../data/priest/Office";
import "../../../static/priestProfile.css";
import CardRow from "../CardRow";
import CardRowForDate from "../CardRowForDate";

interface IOfficeCardProps {
    office: IOffice;
    index: number;
    editMode: boolean;
    handleDelete: (index: number) => void;
    handleChangeOnOffice: (labelName: string, value: any, index: number) => void;
}

const OfficeCard: React.FC<IOfficeCardProps> = (props: IOfficeCardProps) => {
    const { office, index, editMode, handleDelete, handleChangeOnOffice } = props;

    const handleOnClick = () => {
        handleDelete(index);
    };

    return (
        <Card fluid>
            <Card.Content>
                <Card.Content>
                    {editMode ? (
                        <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleOnClick} />
                    ) : (
                        <Card.Header id="header">
                            <Header as="h2">{office.name}</Header>
                        </Card.Header>
                    )}
                </Card.Content>

                <Card.Description>
                    <List>
                        {editMode && (
                            <List.Item>
                                <CardRow
                                    data={office.name}
                                    dataName="name"
                                    editMode={editMode}
                                    index={index}
                                    labelName="officeName"
                                    setValue={handleChangeOnOffice}
                                />
                            </List.Item>
                        )}
                        <List.Item>
                            <CardRowForDate
                                data={office.startDate}
                                editMode={editMode}
                                index={index}
                                labelName="startDate"
                                setValue={handleChangeOnOffice}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRowForDate
                                data={office.endDate}
                                editMode={editMode}
                                index={index}
                                labelName="endDate"
                                setValue={handleChangeOnOffice}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRow data={office.comment} editMode={editMode} index={index} labelName="comment" setValue={handleChangeOnOffice} />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        </Card>
    );
};

export default OfficeCard;
